
import { createI18n } from 'vue-i18n';
import { Locale } from 'vant'

import enUS from 'vant/lib/locale/lang/en-US'
import zhCN from 'vant/lib/locale/lang/zh-CN'
import twCN from 'vant/lib/locale/lang/zh-TW'
import jaJP from 'vant/lib/locale/lang/ja-JP'

import en from './modules/en'; 
import zh from './modules/zh'; 
import tw from './modules/tw'; 
import ja from './modules/ja';

const messages = {
  en: {
    ...enUS,
    ...en,
  },
  tw: {
    ...twCN,
    ...tw,
  },
  zh: {
    ...zhCN,
    ...zh,
  },
  ja: {
    ...jaJP,
    ...ja,
  },
};

export const i18n = new createI18n({
  globalInjection: true,
  locale: localStorage.lang || 'tw', // 默认繁体中文
  legacy: false,
  messages: messages
});

export const setLocales = (lang) => {
  if (lang === 'en') {
    Locale.use(lang, enUS)
  } else if (lang === 'zh') {
    Locale.use('zh', zhCN) 
  } else if (lang === 'tw') {
    Locale.use('tw', twCN)
  } else if (lang === 'ja') {
    Locale.use('ja', jaJP)
  }
  localStorage.setItem('lang', lang)
  i18n.global.locale.value = lang
}

// 获取当前语言
export const getCurrentLang = () => {
  return i18n.global.locale.value
}

// 语言列表
export const languageList = [
  { label: '繁體中文', value: 'tw', icon: '🇹🇼' },
  { label: 'English', value: 'en', icon: '🇺🇸' },
  { label: '日本語', value: 'ja', icon: '🇯🇵' }
]